// components/portal/SourceCampaignLoading.tsx
'use client';

import { memo } from 'react';
import { useKernelStore } from '@/kernel/kernelStores';

export const SourceCampaignLoading = memo(({ sidebar = false }: { sidebar?: boolean }) => {
  const lang = useKernelStore((state) => state.language);
  const name = useKernelStore((state) => {
    const id = state.sourceOpeningCampaignId;
    return id ? state.inventory.Campaign.registry[id]?.config?.name : undefined;
  });
  return (
    <section
      className={`h-full w-full overflow-hidden ${sidebar ? 'p-4' : 'p-[4vmin]'}`}
      aria-busy="true"
      aria-label={lang === 'fr' ? 'Chargement de la campagne' : 'Loading campaign'}
      data-testid={sidebar ? 'campaign-sidebar-loading' : 'campaign-content-loading'}
    >
      {!sidebar && (
        <h1 className="mb-6 truncate text-2xl font-medium text-[#E8E8E8]">
          {typeof name === 'string' && name.trim() ? name : lang === 'fr' ? 'Campagne' : 'Campaign'}
        </h1>
      )}
      <div aria-hidden="true">
        <div className="mb-8 h-4 w-2/5 rounded skeleton" />
        <div className="mb-4 flex h-8 items-center gap-3">
          <div className="h-6 w-24 rounded skeleton" />
          <div className="ml-auto h-6 w-16 rounded skeleton" />
        </div>
        {Array.from({ length: 8 }, (_, index) => (
          <div key={index} className="flex h-12 items-center gap-4 border-t border-[#303030]">
            {!sidebar && <div className="h-6 w-6 shrink-0 rounded skeleton" />}
            <div className="h-3 w-2/5 rounded skeleton" />
            <div className="ml-auto h-3 w-1/5 rounded skeleton" />
          </div>
        ))}
      </div>
    </section>
  );
});

SourceCampaignLoading.displayName = 'SourceCampaignLoading';
